import Counter from 'components/atoms/Counter';
import routes from 'defs/routes';
import * as React from 'react';

type CountTodosProps = {
	count?: number;
	currentViewID?: string;
};

const CountTodos = ({ count, currentViewID }: CountTodosProps) => {
	if (currentViewID === routes.today.indexRoute.id || currentViewID === routes.today.day.id) {
		return null;
	}

	if (!count || count <= 0) {
		return null;
	}

	return (
		<div className="o-header-nav__counter">
			<Counter count={count} />
		</div>
	);
};

export default CountTodos;
